import React from 'react';
import cx from 'clsx';
import { ComponentType } from '../../util/ComponentType';
import classes from './Button.module.scss';

export interface ButtonProps extends React.HTMLProps<HTMLButtonElement> {
  type?: 'button' | 'submit' | 'reset';
  standardWidth?: boolean;
  theme?: 'turquoise' | 'purple';
}

export default function Button<T extends React.ElementType = 'button'>({
  className,
  //@ts-ignore
  component: Element = 'button',
  theme = 'turquoise',
  type = 'button',
  standardWidth,
  children,
  ...others
}: ButtonProps & ComponentType<T>) {
  const linkProps = Element === 'a' ? { rel: 'noopener noreferrer' } : {};
  return (
    //@ts-ignore
    <Element
      data-composable
      className={cx(classes.button, classes[theme], { [classes.standardWidth]: standardWidth }, className)}
      type={type}
      {...linkProps}
      {...others}
    >
      {children}
    </Element>
  );
}

Button.displayName = '@ioa/lablocator/Button';
